import { Link } from "react-router-dom";
import { GraduationCap, Award, ArrowUpRight, Check } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

export default function Startkwalificaties() {
  usePageMeta({
    title: "Startkwalificaties via EVC, LevelLeven",
    description:
      "Deelnemers krijgen startkwalificaties via EVC-trajecten in samenwerking met EVC Centrum VIGOR.",
  });
  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <div className="max-w-3xl reveal">
            <SectionLabel>Startkwalificaties</SectionLabel>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
              Papieren die{" "}
              <span className="italic text-[#E06B3F]">blijven</span>, ook na het programma.
            </h1>
            <p className="mt-8 text-lg text-[#4A5D4E] leading-relaxed font-light">
              Deelnemers verlaten LevelLeven niet met alleen ervaring, maar
              ook met een formeel erkende startkwalificatie. Dat maakt het
              verschil bij werkgevers, in vervolgopleidingen én in
              zelfvertrouwen.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#EFECE5]">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-[#FAF7F1] rounded-3xl border border-[#E5E1D8] p-8">
            <GraduationCap size={22} className="text-[#E06B3F] mb-4" />
            <h2 className="font-heading text-3xl text-[#1D2A22] leading-tight">Hoe: via EVC</h2>
            <p className="mt-4 text-[#4A5D4E] leading-relaxed font-light">
              We gebruiken EVC (Erkenning van Verworven Competenties) om de
              vaardigheden en kennis die deelnemers al bezitten formeel te
              waarderen. Wat mensen al kunnen, vaak zonder het te beseffen,
              wordt zichtbaar en officieel vastgelegd.
            </p>
          </div>
          <div className="bg-[#FAF7F1] rounded-3xl border border-[#E5E1D8] p-8">
            <Award size={22} className="text-[#E06B3F] mb-4" />
            <h2 className="font-heading text-3xl text-[#1D2A22] leading-tight">Met wie: EVC Centrum VIGOR</h2>
            <p className="mt-4 text-[#4A5D4E] leading-relaxed font-light">
              De EVC-trajecten voeren we uit in samenspraak met onze partner{" "}
              <strong className="text-[#1D2A22] font-normal">EVC Centrum VIGOR</strong>, een geaccrediteerde partij die
              volgens de landelijke standaard beoordeelt en certificeert.
            </p>
            <Link
              to="/partners/evc-vigor"
              className="mt-6 inline-flex items-center gap-2 text-sm text-[#E06B3F] hover:text-[#1D2A22] link-underline"
            >
              Meer over VIGOR
              <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Wat het oplevert</SectionLabel>
          <h2 className="font-heading text-4xl sm:text-5xl text-[#1D2A22] leading-tight font-light max-w-2xl">
            Meer dan een certificaat, een{" "}
            <span className="italic text-[#E06B3F]">arbeidsmarktpositie</span>.
          </h2>
          <ul className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              "Erkende startkwalificatie op MBO-2 of hoger niveau (indien passend)",
              "Vervolgstap naar opleiding wordt haalbaar en concreet",
              "Werkgevers zien officieel bewijs van kunde, geen vaag CV meer",
              "Zelfvertrouwen door tastbaar resultaat",
              "Betere uitstroomkansen naar duurzaam werk",
              "Onderdeel van de kwartaalrapportage aan de gemeente",
            ].map((x, i) => (
              <li key={i} className="flex items-start gap-3 bg-[#FAF7F1] rounded-2xl border border-[#E5E1D8] p-5">
                <Check size={18} className="text-[#E06B3F] mt-0.5 shrink-0" />
                <span className="text-[#1D2A22]">{x}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
